































import { computed, defineComponent, ref, useRoute, watch } from '@nuxtjs/composition-api';
import { SfLink, SfList, SfSection } from '@storefront-ui/vue';
import SkeletonLoader from '~/components/SkeletonLoader/index.vue';
import { buildSeoHead } from '~/helpers/buildSeoHead';
import ArticlesList from '../components/ArticlesList.vue';
import { useArticles } from '../composables';
import articlesGetters from '../getters/articlesGetter';
import { useArticlesStore } from '../stores/articles';
import { ArticleCategory, Articles } from '../types';

export default defineComponent({
  name: 'ArticlesListPage',
  components: {
    ArticlesList,
    SfSection,
    SfList,
    SfLink,
    SkeletonLoader,
  },
  setup() {
    const { load } = useArticles();
    const route = useRoute();
    const {
      query: { page, itemsPerPage },
    } = route.value;
    const articlesStore = useArticlesStore();
    const articlesRootCategories = computed(() => articlesStore.rootCategories);
    const articleCategory = computed(() => articlesRootCategories.value.find(
      (category) => String(category.slug) === String(route.value.params?.slug),
    ));
    const rawArticles = ref<Articles | null>(null);

    const hasSubCategories = computed(() => articleCategory.value
      && articleCategory.value.sub_categories
      && articleCategory.value.sub_categories.items);

    const pagination = computed(() => articlesGetters.getPagination(rawArticles.value));
    const articles = computed(() => articlesGetters.getArticles(rawArticles.value));

    watch(
      [articleCategory],
      (newValue) => {
        if (newValue) {
          const queryCategoryId = route.value.query.field_doctor_faq_tid;
          const categoryId = queryCategoryId && queryCategoryId !== 'All'
            ? String(queryCategoryId)
            : String(articleCategory?.value?.id);

          load({
            searchParams: {
              currentPage: page ? Number.parseInt(page.toString(), 10) : 1,
              pageSize: itemsPerPage ? Number.parseInt(itemsPerPage.toString(), 10) : 9,
              category_id: categoryId,
            },
          }).then((result) => {
            rawArticles.value = result;
            return result;
          }).catch((error) => {
            throw error;
          });
        }
      },
      { immediate: true },
    );

    return {
      articles,
      hasSubCategories,
      articleCategory,
      pagination,
      route,
    };
  },
  head() {
    return buildSeoHead({ title: (this.articleCategory as ArticleCategory | undefined)?.name });
  },
});
